import { Icon,Button,PullRefresh,Toast,Area,Popup,Tab,Tabs,DropdownMenu,DropdownItem,Tag,Swipe,SwipeItem  } from 'vant';
import SimpleCard from '../SimpleCard';
import Empty from '../Empty'
import Chatbot from '@/components/Chatbot.vue'
import List from '../list.vue'
import UpdateTime from '../updateTime'
import {Table} from 'view-design';
import 'view-design/dist/styles/iview.css';
import FooterLogo from '../footerLogo'
import Back from '../back'
const components = {
  Icon,
  Button,
  SimpleCard,
  PullRefresh,
  Toast ,
  Area ,
  Popup,
  Empty,
  Chatbot,
  UpdateTime,
  List,
  Tab,
  Tabs,
  DropdownMenu,
  DropdownItem,
  Tag,
  Swipe,
  SwipeItem,
  Table,
  FooterLogo,
  Back
}

// 设置 toast 展示时长, 为 0 时不会消失
Toast.setDefaultOptions('loading',{ duration: 0 });

// 全局注册组件
const install = function (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });
}


export default install;